import { render, staticRenderFns } from "./Ren.vue?vue&type=template&id=7756b135&scoped=true&"
import script from "./Ren.vue?vue&type=script&lang=js&"
export * from "./Ren.vue?vue&type=script&lang=js&"
import style0 from "./Ren.vue?vue&type=style&index=0&id=7756b135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7756b135",
  null
  
)

export default component.exports